export default {
    leftname:"Sunshine Smart Entertainment Merchant Platform",
    loginname:"Please enter your account",
    loginyan:"Please enter the verification code",
    loginpass:"Please enter your account password",
    loginqu:"I am a distributor",
    loginshang:"I am a merchant",
    denglu:"log on",
    qudaoshang:"Channel partners:",
    pingtai:"platform",
    danjisaas:"Single machine operation and maintenance system",
    danjiding:"Single machine order system",
    yangguang:"慧算通 Business management system",
    mendian:"Store operation and maintenance system",
    mendianding:"Store order system",
    quanxian:"Employee Management" ,
    huanying:"Welcome",
    tuichu:"Log Out"  ,
    shanghu:"Merchant：",
    "下载": "Download",
    "收银客户端下载": "Cashier User Download",
    "谷歌浏览器下载": "Google Chrome Download",
    "阳光视翰官网": "Sunshine Official Website",
    "24小时客服热线": "24-Hour Customer Service Hotline",
    "点击跳转": "Click to Jump",
    "点击复制": "Click to Copy",
    "记住密码": "Remember password"
};